import {PdlToastType} from '@/constants/pdl-toast-type';
import store from '@/store';

export function handleKioskLinks() {
  if (store?.state?.backend?.kioskModeEnabledOnSite) {
    const links = document.querySelectorAll('a');
    links.forEach((link) => {
      try {
        const url = new URL(link.href);
        const hostValue = window.location.host;
        const domainValue = hostValue.includes('-') ? hostValue.split('-')[1] : hostValue;
        const isTrekDomain = url.hostname.endsWith(domainValue);

        if (isTrekDomain) {
          link.removeAttribute('target');
          link.setAttribute('target', '_self');
        } else {
          link.removeAttribute('href');
          link.removeAttribute('target');
          link.addEventListener('click', function (event) {
            event.preventDefault(); // prevents the default link behavior (like navigating to #)
            window.vm.config.globalProperties.$notify({
              type: PdlToastType.ERROR,
              message: window.VueI18n.t('errorMessage.unableToOpenExternalLink'),
              showClose: true,
              duration: 5000,
            });
          });
        }
      } catch (e) {
        // If URL parsing fails, treat it as non-trek and disable
        link.removeAttribute('href');
        link.style.cursor = 'default';
      }
    });
  }
}
